import api from './api';

export async function updateShopOpenStatus({ isOpen, reason }) {
  const payload = {
    isOpen: Boolean(isOpen)
  };
  if (typeof reason === 'string' && reason.trim()) {
    payload.reason = reason.trim();
  }
  const { data } = await api.post('/shops/me/status', payload);
  return data;
}

